
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Option bearbeiten</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row></v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          <h3 class="headline">Füllen Sie bitte alle Felder aus.</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="Name"
                            v-model="option.name"
                          ></v-text-field>

                          <v-text-field
                            placeholder="0"
                            outlined
                            value="0"
                            type="number"
                            label="Aufpreis (€)"
                            v-model="option.price"
                          ></v-text-field>

                          <v-text-field outlined label="Externe ID" v-model="option.externalId"></v-text-field>

                          <v-radio-group v-model="option.type">
                            <v-radio label="Motiv" value="motiv"></v-radio>
                            <v-radio label="Option" value="selection"></v-radio>
                          </v-radio-group>

                          <v-file-input
                            outlined
                            show-size
                            v-if="option.type == 'motiv'"
                            accept="image/*"
                            label="Image"
                            v-model="imageFile"
                            :loading="uploadingState == 2"
                            :success="uploadingState == 1"
                            ref="file"
                            @change="uploadImage"
                          ></v-file-input>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-btn large color="primary" @click="create">Speichern</v-btn>
                          <v-btn large color="error" @click="deleteDialog = true">Löschen</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>

                    <v-col v-if="option.url">
                      <v-card>
                        <v-container>
                          <v-img :src="option.url" max-width="300" max-height="300" contain></v-img>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Option Löschen</v-card-title>

        <v-card-text>Möchten Sie diese Option wirklich löschen?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteDialog = false; deleteOption()"
          >Ja, Ich möchte die Option löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import OptionService from "@/services/OptionService";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    imageFile: null,
    deleteDialog: false,
    uploadingState: 0,
    option: {
      name: null,
      url: null,
      type: "motiv",
      price: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async uploadImage(file) {
      this.uploadingState = 2;
      let formData = new FormData();
      formData.set("file", this.imageFile);
      try {
        let fileUrl = (await OptionService.upload(formData)).data;
        this.option.url = fileUrl;
        this.option.name = this.imageFile.name;
        this.loadFont();
      } catch (err) {
        this.uploadingState = 0;
      }
    },

    async create() {
      try {
        this.loading = true;

        //add user
        try {
          let payload = this.option;
          let response = await OptionService.update(
            this.$route.params.id,
            payload
          );
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "Options"
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async deleteOption() {
      try {
        this.loading = true;

        //add user
        try {
          let response = await OptionService.delete(this.$route.params.id);
        } catch (err) {
          alert(err.message);
        }
        this.loading = false;
        router.push({ name: "Options" });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },

    async refresh() {
      this.loading = true;
      try {
        this.option = (
          await OptionService.getOption(this.$route.params.id)
        ).data;
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

